"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgHash = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M28.11 14.006a1 1 0 01.884 1.104L28.45 20H32a1 1 0 010 2h-3.773l-.444 4H32a1 1 0 010 2h-4.439l-.567 5.11a1 1 0 11-1.988-.22L25.55 28h-3.988l-.567 5.11a1 1 0 11-1.988-.22L19.55 28H16a1 1 0 010-2h3.771l.445-4H16a1 1 0 010-2h4.438l.568-5.11a1 1 0 111.988.22L22.45 20h3.988l.568-5.11a1 1 0 011.104-.884zM25.771 26l.445-4h-3.989l-.444 4h3.988z",
    id: "hash_svg__a"
  }));
};

var _default = SvgHash;
exports.default = _default;